import { createFileRoute } from '@tanstack/react-router'
import { Suspense, lazy } from 'react'
import { z } from 'zod'
import { protectedRouteGuard } from '@/utils/routeGuards'

import { Loading } from '@/components/Loading'

const ClustersPage = lazy(
  () => import('@/features/Clusters/pages/ClustersListPage'),
)

const clustersSearchSchema = z.object({
  q: z.string().optional(),
})

export const Route = createFileRoute('/infra/clusters/')({
  validateSearch: clustersSearchSchema,
  beforeLoad: protectedRouteGuard,
  component: () => (
    <Suspense fallback={<Loading />}>
      <ClustersPage />
    </Suspense>
  ),
})
